// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1j-gn","dragIcon":"Choice_dragIcon__2LA3X","left":"Choice_left__10XbL","input":"Choice_input__1cEz4"};